import RoomCapacityAndTime from './RoomCapacityAndTime';

export default RoomCapacityAndTime;
